<template>
  <Modal
    ref="modal"
    :beforeCloseModal="beforeCloseModal"
    :afterOpenModal="afterOpenModal"
    :beforeOpenModal="beforeOpenModal"
    :afterCloseModal="afterCloseModal"
    class="extend__work-permit"
  >
    <p class="extend-permit-hint">{{ extendHint }}</p>
    <div slot="content">
      <div
        class="generalInfo_timePicker"
        v-if="isOpen"
      >
        <DateTimeSelector
          :required="required"
          :date="value"
          :canPutTotop="false"
          :showClearBtn="showClearBtn"
          :setMinTime="setMinTime"
          :disabledDateTimes="disabledDateTimes"
          @updateDate="dateSetter"
        />
      </div>
    </div>
    <div slot="btns">
      <button
        type="button"
        class="btn btn--darkblue"
        @click="cancel"
      >{{ $t('action.cancel') }}</button>
      <button
        type="button"
        class="btn btn--orange"
        :disabled="buttonDisabled"
        @click="extend"
      >
        {{ extendButton }}
      </button>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/controls/Modal'
import DateTimeSelector from '@/controls/DateTimeSelector'
import i18n from '@/utils/i18n'
export default {
  name: 'TimePickerModal',
  components: {
    Modal,
    DateTimeSelector,
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    required: {
      type: Boolean,
      default: true,
    },
    value: {
      type: [String, Number],
      default: null,
    },
    showClearBtn: {
      type: Boolean,
      default: true,
    },
    setMinTime: {
      type: Boolean,
      default: true,
    },
    disabledDateTimes: {
      type: Object,
      default: () => {},
    },
    extendHint: {
      type: String,
      default: i18n.t('workPermit.extendDateHint'),
    },
    extendButton: String,
    beforeOpenModal: {
      type: Function,
      default: () => { return true },
    },
    afterOpenModal: {
      type: Function,
      default: () => {},
    },
    beforeCloseModal: {
      type: Function,
      default: () => {},
    },
    afterCloseModal: {
      type: Function,
      default: () => {},
    },
  },
  data () {
    return {
      isOpen: false,
    }
  },
  computed: {
    modal () {
      return this.$refs.modal
    },
    buttonDisabled () {
      return !this.value
    },
  },
  methods: {
    dateSetter (val) {
      this.$emit('change', val)
    },
    cancel () {
      this.$emit('cancelEvent')
    },
    extend () {
      this.$emit('extendEvent')
    },
    open () {
      this.isOpen = true
      return this.modal.open()
    },
    close () {
      this.isOpen = false
      return this.modal.close()
    },
  },
}
</script>

<style lang="scss" scoped>
  .action-confirm-title {
    font-size: 14px;
    font-weight: bold;
    color: #0c3a58;
  }
  .extend__work-permit {
    .extend-permit-hint {
      font-weight: bold;
    }
  }
  .generalInfo_timePicker {
    .vdp-datepicker {
      vertical-align: bottom;
    }
    .vdp-datepicker, .multiselect {
      display: inline-block;
    }
  }
  .error-highlight {
    .multiselect__tags {
      background-color: #f9ecea !important;
    }
  }
</style>
